import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { PromotionBlackIcon, ThumbUpWhite } from 'images';
import { Button } from 'components/Ui';
import { setTheme } from 'utils/themeHelper';
import { dataLayerPush } from 'utils/tracking';
import { useIsMobile } from 'utils/hooks';
import { translateData } from 'utils/translation';
import { withPromo, PROMOS } from 'components/Promos';
import { PROMOTION_LEARN, PROMOTION_APPLIED, PROMO_NAME } from '../constants';
import styles from './styles.scss';
import LearnPromotion from '../../LearnPromotion';

const PromotionBanner = ({
  content,
  promotionApplied,
  isCartLoading,
  showRedeemDialog,
  page,
}) => {
  const [openLearnMore, setOpenLearnMore] = useState(false);

  const banner = useMemo(
    () =>
      promotionApplied ? content[PROMOTION_APPLIED] : content[PROMOTION_LEARN],
    [promotionApplied],
  );

  const onClickLearnMore = (status) => {
    setOpenLearnMore(status);
  };

  const handleLoad = () => {
    const path = window.location.href;
    const defaultPage = path.includes('/?');
    const quickShopPromo = path.includes('/quick-shop/');

    if (banner.title && !promotionApplied) {
      if (defaultPage) {
        dataLayerPush(
          'Acquisition',
          {
            ecommerce: {
              promoView: {
                promotions: [
                  {
                    name: PROMO_NAME,
                    position: 'Top Promotion Banner',
                  },
                  {
                    name: PROMO_NAME,
                    position: 'Mid Promotion Banner',
                  },
                ],
              },
            },
          },
          'dlA14',
        );
      } else if (quickShopPromo) {
        dataLayerPush(
          'Acquisition',
          {
            ecommerce: {
              promoView: {
                promotions: [
                  {
                    name: PROMO_NAME,
                    position: 'Quick Shop Promo Banner',
                  },
                ],
              },
            },
          },
          'dlA15',
        );
      }
    }
  };

  useEffect(() => {
    handleLoad();
  }, [page]);

  const isMobile = useIsMobile();

  return (
    <>
      <div className={setTheme(styles.promotionBanner, banner, styles)}>
        <div className={styles.content}>
          <div className={styles.controlledContent}>
            <div className={styles.descriptionWrapper}>
              <div className={styles.promotionApplied}>
                {promotionApplied ? (
                  <img src={ThumbUpWhite} alt="" className={styles.icon} />
                ) : (
                  !isMobile && <img src={PromotionBlackIcon} alt="" />
                )}
              </div>
              <div className={styles.title}>{translateData(banner.title)}</div>
              {banner.buttonLabel && (
                <Button
                  className={styles.btn}
                  text={banner.buttonLabel}
                  onClick={() => onClickLearnMore(true)}
                  loading={isCartLoading}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <LearnPromotion
        open={openLearnMore}
        setStatus={setOpenLearnMore}
        displayRedeemDialog={showRedeemDialog}
      />
    </>
  );
};

PromotionBanner.propTypes = {
  promotionApplied: PropTypes.bool,
  isCartLoading: PropTypes.bool,
  content: PropTypes.object,
  showRedeemDialog: PropTypes.func,
  match: PropTypes.shape({
    params: PropTypes.shape({
      page: PropTypes.string,
    }),
  }),
};

export default withPromo(PROMOS.FullPressGuided)(PromotionBanner);
